import { create } from 'zustand';
import { TAuthStore } from './AuthStore.types';
import { clearSession, isAuthenticated as checkAuth } from '../../services/session/loginService';

export const useAuthStore = create<TAuthStore>((set) => ({
	isAuthenticated: checkAuth(),
	isLoading: false,

	setAuthenticated: (value: boolean) => set({ isAuthenticated: value }),

	setLoading: (value: boolean) => set({ isLoading: value }),

	logout: () => {
		clearSession();
		set({ isAuthenticated: false });
	},
}));
